import React from "react";
import { ArrowDown } from "lucide-react";

export const JumpToLatest = ({ visible, onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    aria-hidden={!visible}
    tabIndex={visible ? 0 : -1}
    className={`absolute bottom-5 left-1/2 -translate-x-1/2 z-10 inline-flex items-center gap-2 px-4 py-2 rounded-full
      bg-volt-blue text-white text-sm font-medium shadow-lg shadow-black/40 hover:bg-volt-blue/85
      transition-[opacity,transform] duration-200
      ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`}
  >
    <ArrowDown className="w-4 h-4" />
    Jump to latest
  </button>
);
